import { CHUNK_LOAD_ERROR_PATTERN, RELOAD_COOLDOWN_MS, RELOAD_TIMESTAMP_KEY } from "./consts";

// Route chunks 404 when a deploy replaces the files whose hashes a long-lived tab is
// still holding. Reloading picks up the fresh index.html.
export const isChunkLoadError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return CHUNK_LOAD_ERROR_PATTERN.test(message);
};

// The cooldown keeps a chunk that is broken for any other reason from looping the tab.
export const isReloadOnCooldown = () => {
  try {
    const reloadedAt = Number(window.sessionStorage.getItem(RELOAD_TIMESTAMP_KEY)) || 0;
    return Date.now() - reloadedAt < RELOAD_COOLDOWN_MS;
  } catch {
    // Private mode / blocked storage: treat as on cooldown so we never loop.
    return true;
  }
};

export const markReload = () => {
  try {
    window.sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
  } catch {
    // Nothing to do — worst case the reload guard is a no-op.
  }
};
